import { useEffect, useState } from "react"
import { Home, Loader2 } from "lucide-react"
import { Link } from "react-router"

import * as settingsService from "@/services/settingsService"
import type { GalleryAlbum } from "@/services/settingsService"
import { GalleryAlbumCard } from "./GalleryAlbumCard"
import { STATIC_GALLERY_ALBUMS } from "./gallery-fallback"

export const ImageLibraryPage = () => {
  const [albums, setAlbums] = useState<GalleryAlbum[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    async function fetchGallery() {
      try {
        const data = await settingsService.getGallery()
        if (!cancelled) setAlbums(data.length > 0 ? data : STATIC_GALLERY_ALBUMS)
      } catch (error) {
        console.warn("Không tải được thư viện ảnh, đang dùng dữ liệu dự phòng", error)
        if (!cancelled) setAlbums(STATIC_GALLERY_ALBUMS)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    void fetchGallery()
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="min-h-screen bg-[#fffdf9] text-[#30291f]">
      <section className="bg-[#3F3323] px-5 pb-16 pt-24 text-center text-[#f3ecdf] sm:px-8 sm:pb-20 sm:pt-28 lg:pb-24">
        <div className="mx-auto max-w-[1180px]">
          <nav
            aria-label="Breadcrumb"
            className="flex items-center justify-center gap-2 text-xs text-[#d7c8b4] sm:text-sm"
          >
            <Link to="/" className="inline-flex items-center gap-1.5 transition-colors hover:text-white">
              <Home className="size-3.5" aria-hidden="true" />
              Trang chủ
            </Link>
            <span aria-hidden="true">›</span>
            <span className="text-white">Thư viện ảnh</span>
          </nav>

          <p className="mt-8 text-[10px] font-semibold uppercase tracking-[0.38em] text-[#c1a35f] sm:mt-10">
            Nhà Cam Homestay
          </p>
          <h1 className="mt-3 font-serif text-4xl font-semibold tracking-tight text-[#f7f0e4] sm:text-5xl lg:text-6xl">
            Thư viện ảnh
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-6 text-[#d7c8b4] sm:text-base">
            Khám phá không gian và những trải nghiệm bình yên tại Nhà Cam.
          </p>
        </div>
      </section>

      <main className="mx-auto max-w-[1180px] px-5 pb-24 pt-14 sm:px-8 sm:pb-28 sm:pt-16 lg:pb-32 lg:pt-20">
        {loading ? (
          <div className="flex min-h-[360px] items-center justify-center text-[#796a59]">
            <Loader2 className="size-6 animate-spin text-[#c1a35f]" aria-hidden="true" />
            <span className="ml-3 text-sm">Đang tải thư viện ảnh...</span>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-7">
            {albums.map((album) => (
              <GalleryAlbumCard key={album.id} album={album} />
            ))}
          </div>
        )}
      </main>
    </div>
  )
}
